<script setup>
import { ref, computed, watch } from 'vue'
import { useAppStore } from '@/stores/app'
import { useDataStore } from '@/stores/data'
import FloatingDialog from './FloatingDialog.vue'

const appStore = useAppStore()
const dataStore = useDataStore()

const logout = () => {
	dataStore.clearUser()
	appStore.initializing = true
	setTimeout(() => {
		document.location.reload()
	}, 1000)
}

const clearTrips = () => {
	dataStore.clearTrips()
	setTimeout(() => {
		document.location.reload()
	}, 200)
}

const showDeveloperOptions = computed(() => {
	if (appStore.currentPage == 'intro' || appStore.currentPage == 'approved') {
		return true
	}
	return false
})

const copyToClipboard = () => {
	navigator.clipboard.writeText(dataStore.appInstallationId).then(
		function () {
			appStore.toast({ message: 'Din applikasjons-ID ble kopiert til utklippstavlen', type: 'success' })
		},
		function (err) {
			console.warn('Could not copy text', err)
		},
	)
}

const toggleFeature = (featureName) => {
	postMessage({ type: 'toggleFeature', feature: featureName })
}
</script>

<template>
	<FloatingDialog :disabled="!showDeveloperOptions" v-model:expanded="appStore.expandedDeveloperOptions" icon="fa-solid fa-code" title="Utviklervalg" position="top-right" button-class="fixed bigshadow roundButton text-gray-900">
		<div v-if="dataStore.respondentAltId" class="mt-3 rounded-lg smallbox flex justify-between">
			<div>
				<strong>{{ dataStore.respondentName }}</strong>
				<br />{{ dataStore.respondentAltId }}
			</div>
			<div class="flex justify-center items-center" @click="logout()">
				<div class="round-button black"><i color="success" class="fas fa-right-from-bracket"></i></div>
			</div>
		</div>
		<div v-if="dataStore.appInstallationId" class="mt-3 rounded-lg smallbox flex justify-between" @click="copyToClipboard()">
			<div>
				<strong>Din applikasjons-ID</strong><br />
				{{ dataStore.appInstallationId }}
			</div>
			<div class="flex justify-center items-center">
				<div class="round-button"><i color="success" class="fas fa-copy"></i></div>
			</div>
		</div>
		<div v-if="dataStore.savedDays && Object.keys(dataStore.savedDays).length" class="mt-3 smallbox flex justify-between" @click="clearTrips()">
			<div>
				<strong>Slett alle godkjente reisedager</strong><br />
				{{ dataStore.savedDays.length }} reisedager og {{ dataStore.savedDays.reduce((acc, day) => acc + day.journeys.filter((j) => j.verified).length, 0) }} reiser
			</div>
			<div class="flex justify-center items-center">
				<div class="round-button red"><i color="success" class="fas fa-trash"></i></div>
			</div>
		</div>
		<div class="mt-3 rounded-lg smallbox flex justify-between" style="background-color: #d7efff" @click.stop="toggleFeature('userCanChangeDates')">
			<div>
				<strong>Datovelger</strong><br />
				Tilgang til å endre reisedato
			</div>
			<div class="flex justify-center items-center">
				<div class="round-button" :class="{ black: dataStore.userCanChangeDates }"><i color="success" :class="[dataStore.userCanChangeDates ? 'fa-solid fa-check' : 'fa-regular fa-square']"></i></div>
			</div>
		</div>
		<div class="mt-3 rounded-lg smallbox flex justify-between" style="background-color: #d7efff" @click.stop="toggleFeature('userCanUndo')">
			<div>
				<strong>Angring</strong><br />
				Tilgang til å tilbakestille godkjente reisedager
			</div>
			<div class="flex justify-center items-center">
				<div class="round-button" :class="{ black: dataStore.userCanUndo }"><i color="success" :class="[dataStore.userCanUndo ? 'fa-solid fa-check' : 'fa-regular fa-square']"></i></div>
			</div>
		</div>
	</FloatingDialog>
</template>
